
import { useState } from "react";
import { useNavigate } from "react-router-dom";

import { Button } from "@/components/ui/button";
import { SkipButton } from "@/components/onboarding/skip-button";
import { StepSuccess } from "@/components/onboarding/step-success";
import { DownloadAppButton } from "@/components/download-app-button";

interface OnboardingDownloadAppProps {
  onSkip: () => void;
  onSuccess: () => void;
  initialConnected?: boolean;
}

export function OnboardingDownloadApp({
  onSkip,
  onSuccess,
  initialConnected = false,
}: OnboardingDownloadAppProps) {
  const navigate = useNavigate();
  const [isConnected, setIsConnected] = useState(initialConnected);

  const handleDeviceConnected = () => {
    setIsConnected(true);
    onSuccess();
  };

  const handleContinue = () => {
    navigate("/onboarding/notification");
  };

  if (isConnected) {
    return (
      <div className="max-w-md mx-auto space-y-6">
        <StepSuccess
          title="App connected successfully!"
          description="Please enable notifications on your device"
        />

        <div className="flex justify-center">
          <Button onClick={handleContinue}>Continue</Button>
        </div>
      </div>
    );
  }

  return (
    <div className="max-w-md mx-auto space-y-6">
      <div className="flex justify-center py-8">
        <DownloadAppButton size="lg" onDeviceConnected={handleDeviceConnected} />
      </div>

      <div className="flex justify-center">
        <SkipButton onClick={onSkip} />
      </div>
    </div>
  );
}
